<template>
    <div>
        <b-card header-tag="header" class="m-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
                    Relatórios da LRF e CI
                    <b-button size="sm" class="float-right m-1" to="/entrega/enviar-lrf-ci">
                        <font-awesome-icon icon="plus" class="mr-3" />
                        Enviar relatório
                    </b-button>
                </h6>
            </template>
            <b-card-body>
                <card-filtros-busca>
                    <b-form @submit.prevent="filtrarRelatorios" @reset.prevent="limparFiltros" v-if="showFilters">
                        <b-row>
                            <b-col cols="6" lg="4">
                                <b-form-group id="input-group-type" label-size="md" label="Ano">
                                    <b-form-select id="select-filtros-ano" v-model="filtros.ano" :options="comboAnos">
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6" lg="4">
                                <b-form-group id="input-group-type" label-size="md" label="Tipo de Relatório">
                                    <b-form-select id="select-filtros-tipoDeRelatorio" v-model="filtros.tipoDeRelatorio"
                                        :options="comboTiposDeRelatorio" @change="updatePeriodos">
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6" lg="4">
                                <b-form-group id="input-group-type" label-size="md" label="Período">
                                    <b-overlay :show="loadingPeriodos">
                                        <b-form-select id="select-filtros-periodo" v-model="filtros.periodo"
                                            :options="comboPeriodos" :disabled="!comboPeriodos.length">
                                        </b-form-select>
                                    </b-overlay>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6" lg="4">
                                <b-form-group id="input-group-type" label-size="md" label="Situação">
                                    <b-form-select id="select-filtros-situacao" v-model="filtros.situacao"
                                        :options="comboSituacoes">
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="6" lg="4" class="pt-4">
                                <b-button type="reset" variant="outline-secondary">
                                    <font-awesome-icon icon="redo" class="mr-3" />Limpar
                                </b-button>
                            </b-col>
                            <b-col cols="6" lg="4" class="pt-4">
                                <b-button type="submit">
                                    <font-awesome-icon icon="search" class="mr-3" />Filtrar
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>

                </card-filtros-busca>
                <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="items" sort-by=""
                    :sort-desc="true" striped stacked="lg" :current-page="currentPage" show-empty>
                    <template #empty>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #emptyfiltered>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-dark">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong class="loading-text">Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <div class="actions-icons">
                            <b-link class="text-dark" @click="verDetalhes(row.item)">
                                <font-awesome-icon icon="eye" />
                                <div style="font-size: 12px">Ver detalhes</div>
                            </b-link>
                        </div>
                    </template>
                </b-table>
                <table-pagination v-if="totalRows" :total-rows="totalRows" :per-page="pageSize" @pageChange="pageChange" />
            </b-card-body>
        </b-card>
    </div>
</template>

<script lang="ts">
import { store } from "@/store";
import { TableField } from '@/types/table-field'
import { SelectValue } from '@/types/select-value'
import { Vue, Component } from 'vue-property-decorator'
import lrfService from "@/services/entregas/lrfService"
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import { PrestacaoDeContasLRFCI } from '@/types/entregas/lrfci/prestacao-contas-lrfci'
import { fieldsPrestacaoContasLRFCI } from '@/types/entregas/lrfci/fields-prestacao-contas-lrfci'
import { FiltrosPrestacaoContasLRFCI } from '@/types/entregas/lrfci/filtros-prestacao-contas-lrfci'

const CompProps = Vue.extend({
    name: 'ConsultaRelatoriosLRFCI',
    components: { CardFiltrosBusca, TablePagination },
})

@Component
export default class ConsultaRelatoriosLRFCI extends CompProps {
    fields: TableField[] = fieldsPrestacaoContasLRFCI
    filtros: FiltrosPrestacaoContasLRFCI = new FiltrosPrestacaoContasLRFCI()
    items: PrestacaoDeContasLRFCI[] = []
    comboAnos: SelectValue[] = []
    comboPeriodos: SelectValue[] = []
    comboTiposDeRelatorio: SelectValue[] = []
    comboSituacoes: SelectValue[] = []
    showFilters = true
    tableBusy = false
    loadingPeriodos = false
    
    //paginação
    pageSize = 10
    totalRows = 0
    currentPage = 1

    async mounted() {
        try {
            store.blockScreen = true
            this.filtros.limpar()
            await this.getCombos()
            await this.buscarRelatorios()
        } finally {
            store.blockScreen = false
        }
    }

    async getCombos() {
        const combos = await lrfService.getCombosConsultaLRF()
        this.comboAnos = [
            ...combos.anosEntrega.map(ae => ({ text: String(ae), value: ae }))
        ]
        this.comboTiposDeRelatorio = [
            { text: 'SELECIONE', value: '', disabled: true },
            ...combos.tiposRelatorio.map(tr => {
                //console.log(tr)
                return { text: tr.DeTiporelatorio, value: tr.IdTiporelatorio }
            })
        ]
        this.comboSituacoes = [
            { text: 'SELECIONE', value: '', disabled: true },
            ...combos.situacoes.map(s => { return { text: s.DsStatusPc, value: s.IdStatusPc } })
        ]
        this.comboAnos[0]?.value 
            ? this.complementaAno(this.comboAnos[0]?.value)
            : this.comboAnos.unshift({ text: 'SELECIONE', value: '', disabled: true })
    }

    complementaAno(limite: number | string) {
        const anoInicial = 2017
        for (let ano = anoInicial; ano < Number(limite); ano++) {
            this.comboAnos.push({ text: String(ano), value: ano })
        }
        this.comboAnos.sort((a, b) => {
            const aValue = Number(a.value) || 0
            const bValue = Number(b.value) || 0
            return bValue - aValue
        })
        this.comboAnos.unshift({ text: 'SELECIONE', value: '', disabled: true })
    }

    async updatePeriodos(novoTipoRelatorio: string) {
        try {
            this.loadingPeriodos = true
            const periodos = await lrfService.getPeriodosRelatorio(novoTipoRelatorio)
            //console.log(periodos)
            if (periodos && periodos.length > 0) {
                this.comboPeriodos = [
                    { text: 'SELECIONE', value: '', disabled: true },
                    ...periodos.map(p => { return { text: p.DePeriodorelatorio, value: p.IdPeriodorelatorio } })
                ]
            } else {
                this.comboPeriodos.slice(0)
                this.filtros.periodo = ''
            }
        } finally {
            this.loadingPeriodos = false
        }
    }

    async filtrarRelatorios(){
        this.items = []
        this.totalRows = 0
        await this.pageChange(1)
    }

    async pageChange(value: number) {
        this.currentPage = value;
        await this.buscarRelatorios();
    }

    async buscarRelatorios(): Promise<void> {
        this.tableBusy = true
        try {
            const response = await lrfService.consultarLRF(this.filtros, this.currentPage);
            if (response && response.status === 200) {
                this.totalRows = response.data.totalRows
                this.currentPage = response.data.page || 1
                this.pageSize = response.data.pageSize || 10
                 this.items = response.data.lrfs.map((pr: any) => {
                    const retorno = Object.assign(new PrestacaoDeContasLRFCI(), pr)
                    retorno.tratarDadosDaAPI()
                    return retorno
                })
            } else {
                throw new Error(response.data && response.data.msg 
                    ? response.data.msg 
                    : 'Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!'
                )
            }
        } catch (e: any) {
            console.error(e)
            this.items = []
            this.$toast.error(e.message ? e.message : e);
        } finally {
            this.tableBusy = false
        }
    }
    verDetalhes(relatorioSelecionado: PrestacaoDeContasLRFCI) {
        this.$router.push(`/entrega/detalhes-lrf-ci/${relatorioSelecionado.IdPrestcontasLrfci}`);
    }
    limparFiltros(): void {
        this.filtros.limpar()
        this.comboPeriodos.slice(0)
        // Trick to reset/clear native browser form validation state
        this.showFilters = false
        this.$nextTick(() => {
            this.showFilters = true
        })
    }
}
</script>
